/* eslint-disable react/prop-types */
import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import HeaderPDF from './HeaderPDF';
// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 20,
    color: '#2c3e50',
  },
  section: {
    marginBottom: 15,
    padding: 10,
    backgroundColor: '#f8f9fa',
    borderRadius: 5,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#34495e',
    borderBottom: '1px solid #bdc3c7',
    paddingBottom: 5,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  column: {
    flex: 1,
    marginRight: 10,
  },
  label: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#7f8c8d',
    marginBottom: 2,
  },
  value: {
    fontSize: 10,
    color: '#2c3e50',
    marginBottom: 8,
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5,
  },
  checkbox: {
    width: 8,
    height: 8,
    border: '1px solid #34495e',
    marginRight: 5,
    backgroundColor: '#ffffff',
  },
  checkedBox: {
    width: 8,
    height: 8,
    border: '1px solid #34495e',
    marginRight: 5,
    backgroundColor: '#27ae60',
  },
  checkboxText: {
    fontSize: 9,
    color: '#2c3e50',
  },
  signatureSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  signatureBox: {
    width: '45%',
    padding: 10,
    border: '1px solid #bdc3c7',
    borderRadius: 5,
  },
  signatureTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center',
    color: '#34495e',
  },
  footer: {
    marginTop: 20,
    padding: 10,
    borderTop: '1px solid #bdc3c7',
    fontSize: 8,
    color: '#7f8c8d',
    textAlign: 'center',
  }
});

const ExportPDFFdwRestDayAgreement = ({ user, data, agencyInfo }) => {


  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <HeaderPDF user={user} agencyInfo={agencyInfo} />
        <Text style={styles.title}>FDW Rest Day Agreement</Text>
        
        {/* Parties Information */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Parties Information</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>FDW Name:</Text>
              <Text style={styles.value}>{data.fdwName || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>FDW Work Permit:</Text>
              <Text style={styles.value}>{data.fdwWp || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Employer Name:</Text>
              <Text style={styles.value}>{data.employerName || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Employer NRIC:</Text>
              <Text style={styles.value}>{data.employerNric || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Agreement Details */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Agreement Details</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Agreement:</Text>
              <Text style={styles.value}>{data.agreement || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Compensation Amount:</Text>
              <Text style={styles.value}>{data.compAmount || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Variation Details */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Variation Details</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Variation:</Text>
              <Text style={styles.value}>{data.variation || 'Not specified'}</Text>
            </View>
          </View>
          
          {/* Rest Options */}
          <View style={styles.checkboxContainer}>
            <View style={data.restInLieu ? styles.checkedBox : styles.checkbox} />
            <Text style={styles.checkboxText}>Rest in lieu</Text>
          </View>
          <View style={styles.checkboxContainer}>
            <View style={data.restForgone ? styles.checkedBox : styles.checkbox} />
            <Text style={styles.checkboxText}>Rest forgone</Text>
          </View>
          <View style={styles.checkboxContainer}>
            <View style={data.compensation ? styles.checkedBox : styles.checkbox} />
            <Text style={styles.checkboxText}>Compensation</Text>
          </View>
          
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Rest Worked:</Text>
              <Text style={styles.value}>{data.restWorked || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Signatures */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Original Agreement Signatures</Text>
          <View style={styles.signatureSection}>
            <View style={styles.signatureBox}>
              <Text style={styles.signatureTitle}>FDW Signature</Text>
              <Text style={styles.label}>Signature:</Text>
              <Text style={styles.value}>{data.fdwSignature || ''}</Text>
              <Text style={styles.label}>Date:</Text>
              <Text style={styles.value}>{data.fdwDate || ''}</Text>
            </View>

            <View style={styles.signatureBox}>
              <Text style={styles.signatureTitle}>Employer Signature</Text>
              <Text style={styles.label}>Signature:</Text>
              <Text style={styles.value}>{data.employerSignature || ''}</Text>
              <Text style={styles.label}>Date:</Text>
              <Text style={styles.value}>{data.employerDate || ''}</Text>
            </View>
          </View>
        </View>

        {/* Variation Signatures */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Variation Signatures</Text>
          <View style={styles.signatureSection}>
            <View style={styles.signatureBox}>
              <Text style={styles.signatureTitle}>FDW Signature (Variation)</Text>
              <Text style={styles.label}>Signature:</Text>
              <Text style={styles.value}>{data.fdwSignatureVar || ''}</Text>
              <Text style={styles.label}>Date:</Text>
              <Text style={styles.value}>{data.fdwDateVar || ''}</Text>
            </View>

            <View style={styles.signatureBox}>
              <Text style={styles.signatureTitle}>Employer Signature (Variation)</Text>
              <Text style={styles.label}>Signature:</Text>
              <Text style={styles.value}>{data.employerSignatureVar || ''}</Text>
              <Text style={styles.label}>Date:</Text>
              <Text style={styles.value}>{data.employerDateVar || ''}</Text>
            </View>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text>FDW Rest Day Agreement Generated on {new Date().toLocaleDateString()}</Text>
          {user && (
            <Text>Agency: {user.company?.name || 'Not specified'}</Text>
          )}
        </View>
      </Page>
    </Document>
  );
};

export default ExportPDFFdwRestDayAgreement;
